module.exports = __webpack_public_path__ + "media/images/icon__settings@2x-b20cab9492bc400595f9ade859a9f617.png";